(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.messages');
    module.controller('MessageActivityController', 
        ['activityData', '$uibModalInstance', MessageActivityControllerFn]);

    /* message activity controller */
    function MessageActivityControllerFn(activityData, $uibModalInstance) {
        /* jshint validthis:true */
        var vm = this;
        // data 
        vm.activityData = {};
        vm.appointmentsVisible = true;
        vm.tasksVisible = true;
        vm.usersVisible = true;

        vm.toggleAppointmentVisibility = function () {
            vm.appointmentsVisible = !vm.appointmentsVisible;
        };

        vm.toggleTaskVisibility = function () {
            vm.tasksVisible = !vm.tasksVisible;
        };

        vm.toggleUserVisibility = function () {
            vm.usersVisible = !vm.usersVisible;
        };

        vm.closeModal = function() {
            $uibModalInstance.close();
        };

        activate();

        function activate() {
            vm.activityData = activityData;
        }
    }
})();
